/*
These functions make sure WordPress
and Foundation play nice together.
*/
//create params

jQuery(document).ready(function() {

if(jQuery( "body" ).hasClass( "home" )){

//SWIPER
	var swiperInfo = new Swiper('.swiper-info', {
		effect: 'fade',
		fadeEffect: {
			crossFade: false
		},
		shortSwipes : false,
		longSwipes : false,
		touchRatio: 0,
		direction: 'horizontal',
		slidesPerView : 1,

	});
		var swiperHome = new Swiper('.swiper-home', {
		direction: 'vertical',
		slidesPerView : 'auto',
		mousewheel: {
			invert: false,
			//eventsTarged:'swiper-home ',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		controller: {
			control:swiperInfo,
		},
		on: {
			slideChange: function () {
				//jQuery('.info-panel').removeClass('open-panel');
				if(actif != null){
					jQuery('.main').removeClass('poster-close');
					actif.children(".video-projet").get(0).player.pause();
					actif.children(".video-projet").get(0).player.currentTime(0);
				}
				jQuery('.main').removeClass('control-inactive');
			},
		}
	});

//PANEL

	jQuery('body').on('click','.open-info , .close-info',function(){
		jQuery('.info-panel').toggleClass('open-panel');
	});

//POSTER
	var actif;
	jQuery('body').on('click','.swiper-slide-active .image-poster, .play-button',function(){
		if(actif != null){
			jQuery('.main').removeClass('poster-close');
			actif.children(".video-projet").get(0).player.pause();
			actif.children(".video-projet").get(0).player.currentTime(0);
		}
		actif = jQuery('.swiper-home .swiper-slide-active');
		jQuery('.main').addClass('poster-close');
		jQuery('.swiper-slide-active .video-projet').get(0).player.play();
		jQuery('.info-panel').removeClass('open-panel');
	});

//VIDEO
	var videos = [];
	for(let i = 0; i<swiperHome.slides.length-1;i++){
		videos[i]=videojs('video-'+i,{
			controls:true,
			autoplay: false,
			preload: 'none',
		});
		videos[i].on("useractive",function(){
			console.log("index: "+i);
			if(i == swiperHome.activeIndex){
				jQuery('.main').removeClass('control-inactive');
			}
		});
		videos[i].on("userinactive",function(){
			if(i == swiperHome.activeIndex){
				jQuery('.main').addClass('control-inactive');
			}
		});
		videos[i].on("ended",function(){
			if(i == swiperHome.activeIndex){
				swiperHome.slideNext();
				jQuery('.main').removeClass('control-inactive');
			}
		});
	}
}

if(jQuery( "body" ).hasClass( "archive" )){
	var video;
	var swiperArchive = new Swiper('.swiper-article', {
		direction: 'vertical',
		slidesPerView : 'auto',
		freeMode: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			hide: false,
			draggable: true,
		},
		mousewheel: {
			invert: false,
			eventsTarged:'.main',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		breakpoints: {
			// when window width is >= 640px
			800: {
				direction: 'horizontal',
				slidesPerColumnFill:'column',
				freeMode : false,
			}
		}
	});

	jQuery('body').on('click', '.projet ', function() {

			var input = jQuery(this);
			var number = input.attr("projectid");
			jQuery.post(
			    ajaxurl,
			    {
			        'action': 'mon_action',
			        'param': number
			    },
			    function(response){


						jQuery('.project-panel').empty();
					 	var splitted = response.split("<!-- break -->");
						 jQuery('#media-panel').append(splitted[0]);
						 jQuery('#info-panel .content').append(splitted[1]);
						 jQuery('body').addClass('show-content');
						 video=videojs('video',{
							controls:true,
							autoplay: false,
							preload: 'auto',
						});
						var data = jQuery(".info h2").text();
						var html = jQuery(".info .slug").text()
						history.pushState(data, data, html);
	        }
			);
		});
		jQuery('body').on('click','.close-content',function(){
			jQuery('body').removeClass('show-content');
			setTimeout(function(){
				video.dispose();
			},450)
			history.back();
		});


		function resize() {
			if (window.matchMedia("(min-width: 640px)").matches) {
				jQuery('.swiper-article .swiper-slide article').width(	jQuery('.swiper-article .swiper-slide article').height());
			} else {
				jQuery('.swiper-article .swiper-slide article').height(	jQuery('.swiper-article .swiper-slide article').width());
			}
				swiperArchive.update();
	  }
		resize();
		window.onresize = resize;
	};


	if(jQuery( "body" ).hasClass( "single-projet" )){
			var video=videojs('video',{
			 controls:true,
			 autoplay: false,
			 preload: 'auto',
		});
	};
});
jQuery('body').on('click','.menu-mobile-button',function(){
	jQuery('.mobile-menu,body').toggleClass("open");
	//jQuery('body').toggleClass("open");
});
